<div class="default-dialog">
    <div class="dialog-header">
        <h3>{{ 'EDIT.DIALOG.TEMPLATE.TITLE' | translate }}</h3>
    </div>

    <mat-dialog-content>
        <form [formGroup]="editForm">
            <div class="content-action">
                <div class="default-form-field">
                    <mat-label>{{ 'COMMON.DIALOG.CUSTOMER_PURCHASE_NUMBER.LABEL' | translate }}</mat-label>
                    <mat-form-field class="bordered-field" appearance="outline">
                        <input
                            type="text"
                            matInput
                            [placeholder]="'COMMON.DIALOG.CUSTOMER_PURCHASE_NUMBER.PLACEHOLDER' | translate"
                            formControlName="customerPurchaseNumber"
                        />
                    </mat-form-field>
                </div>
                <div class="default-form-field">
                    <mat-label>{{ 'COMMON.DIALOG.DESCRIPTION.LABEL' | translate }}</mat-label>
                    <mat-form-field class="bordered-field" appearance="outline">
                        <input
                            type="text"
                            matInput
                            [placeholder]="'COMMON.DIALOG.DESCRIPTION.PLACEHOLDER' | translate"
                            formControlName="templateDescription"
                        />
                    </mat-form-field>
                </div>
                <div class="default-form-field">
                    <mat-label>{{ 'COMMON.DIALOG.PRIMARY_SCHEME.LABEL' | translate }}</mat-label>
                    <mat-form-field class="bordered-field" appearance="outline">
                        <input
                            type="text"
                            matInput
                            [placeholder]="'COMMON.DIALOG.PRIMARY_SCHEME.PLACEHOLDER' | translate"
                            formControlName="primarySchemes"
                        />
                    </mat-form-field>
                </div>
            </div>
        </form>
    </mat-dialog-content>

    <mat-dialog-actions>
        <button mat-stroked-button color="primary" [mat-dialog-close]="false">
            {{ 'COMMON.DIALOG.CANCEL' | translate }}
        </button>
        <button mat-flat-button color="primary" [mat-dialog-close]="dialogResult" [disabled]="!editForm.valid">
            {{ 'COMMON.DIALOG.CONFIRM' | translate }}
        </button>
    </mat-dialog-actions>
</div>
